import React from 'react';
import {Checkbox, FormControlLabel, Typography, Link, Grid} from "@mui/material";
import {AccountType} from "./constants/securspace-constants";
import {Link as RouterLink} from "react-router";
import { isBuyerAccountType } from "../util/AccountUtils";

interface TermsAndPolicyCheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  accountType?: string;
  name: string;
  disabled?: boolean;
  externalForm?: boolean;
  // Checkbox to the left of the agreement text, which becomes its label (no separate "Agree to Terms").
  inline?: boolean;
}

const agreementLabelSx = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '0.92em',
  lineHeight: '138%',
  letterSpacing: '0.01em',
  marginTop: '0.79em',
} as const;

const agreementLabelPartnerSx = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '0.92em',
  lineHeight: '1.4em',
  letterSpacing: '0.01em',
  marginTop: '0.79em',
} as const;

const linkSx = {
  fontSize: '0.92em',
  color: 'rgba(63, 81, 181, 1)',
  textDecoration: 'none',
} as const;

const requiredSx = {
  '&.Mui-required': {
    color: 'tomato',
  },
} as const;

const externalFormSpacingSx = {
  flexDirection: 'column',
} as const;

const TermsAndPolicyCheckbox = (props: TermsAndPolicyCheckboxProps) => {
  const {checked, onChange, accountType = AccountType.BUYER, name, disabled = false, externalForm = false, inline = false} = props;

  const agreementText = <>
    I agree to the SecurSpace <RouterLink to={'/terms-of-use'} target={'_blank'} style={linkSx}>Terms Of Use</RouterLink> and <RouterLink to={'/privacy-policy'} target={'_blank'} style={linkSx}>Privacy Policy</RouterLink>, as well as our supplier <Link href={'https://www.dwolla.com/legal/tos/'} target={'_blank'} rel="noopener noreferrer" sx={linkSx}>Dwolla&#39;s Terms of Service</Link> and <Link href={'https://www.dwolla.com/legal/privacy/'} target={'_blank'} rel="noopener noreferrer" sx={linkSx}>Privacy Policy</Link>
  </>;
  const agreementSx = isBuyerAccountType(accountType) ? agreementLabelSx : agreementLabelPartnerSx;

  if (inline) {
    return (
      <FormControlLabel
        required
        sx={{...requiredSx, alignItems: 'flex-start', m: 0}}
        control={<Checkbox checked={checked} onChange={onChange} name={name} disabled={disabled} sx={{py: 0}}/>}
        label={<Typography component='span' sx={{...agreementSx, marginTop: 0}} color='textPrimary'>{agreementText}</Typography>}
      />
    );
  }

  return (
    <Grid container sx={externalForm ? externalFormSpacingSx : undefined}>
        <Grid item>
          <Typography component='p' sx={agreementSx} color='textPrimary'>
            {agreementText}
          </Typography>
        </Grid>
        <Grid item>
          <FormControlLabel
            sx={requiredSx}
            label={<Typography variant={'subtitle1'} sx={agreementLabelSx} color='textPrimary' component='span'>Agree to Terms</Typography>}
            control={<Checkbox checked={checked} onChange={onChange} name={name} disabled={disabled} required/>}
            />
        </Grid>
    </Grid>
  );
};

export default TermsAndPolicyCheckbox;
